import React from 'react'
import {Row} from 'react-bootstrap'
import FlatButton from 'material-ui/FlatButton'
import {Card, CardTitle} from 'material-ui/Card'

import TransactionIcon from 'material-ui/svg-icons/action/payment'

const styles = {
  card: {
    flex: 1,
    paddingBottom: 10
  }
}

class Reports extends React.Component {
  render () {
    return (
      <div>
        <Row>
          <Card style={styles.card}>
            <CardTitle title='Relatórios' />
            <FlatButton 
              primary
              label='Abastecimentos'
              icon={<TransactionIcon />}
              onClick={() => { window.location = '/#/transactionReport' }}
            />
          </Card>
        </Row>
      </div>
    )
  }
}

export default Reports



// WEBPACK FOOTER //
// ./src/collections/reports.js